import { gql } from '@apollo/client'

export const ProductFragment = gql`
  fragment Product on Product {
    id
    master
    name
    images
    price
    brand
    group
    category
    color
    slug
  }
`
